import { Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Pressable } from 'native-base';
import React from 'react';

import { hideUpdate } from '../../constants';

export namespace TradingListButtonRefreshTypes {
  export interface Props {
    onRefresh?: () => void;
    updatedAt?: Date;
  }
}

export const ButtonRefresh: React.FC<TradingListButtonRefreshTypes.Props> = ({
  onRefresh,
  updatedAt,
}) => {
  if (hideUpdate) {
    return <></>;
  }

  return (
    <VStack>
      <Pressable alignItems={'flex-end'} testID="refresh-button" onPress={onRefresh}>
        <HStack space={1} alignItems="center" justifyContent="center">
          <Text
            py={1.5}
            alignSelf="center"
            textAlign="center"
            color="brand.tertiary.principal"
            variant="semibold"
            fontSize={Typography['fontsize.xs']}>
            ATUALIZAR
          </Text>
          <Icon
            testId="button-icon-refresh"
            name="Refresh"
            size="xxs"
            color={Color['brand.tertiary.principal']}
          />
        </HStack>
      </Pressable>
      <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
        Atualizado em {Utils.Mask.DateFormat(updatedAt, 'dd/MM HH:mm:ss')}
      </Text>
    </VStack>
  );
};
